<div class="apple-multiselect">
  <div #trigger class="apple-multiselect-trigger" (click)="toggleDropdown($event)" [class.open]="isOpen">
    <div class="apple-multiselect-content">
      @if (multiple) {
        @if (selectedValues.length === 0) {
          <span class="placeholder">{{ placeholder }}</span>
        }
        @if (selectedValues.length > 0) {
          @for (value of selectedValues; track value) {
            <span class="pill">{{ value }}</span>
          }
        }
      }
      @if (!multiple) {
        <span [class.placeholder]="!selectedValue">{{ displayText }}</span>
      }
    </div>
    <div class="apple-multiselect-arrow">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <polyline points="6,9 12,15 18,9"></polyline>
      </svg>
    </div>
  </div>

  <ng-template #dropdownTpl>
    <div class="apple-multiselect-panel" (click)="$event.stopPropagation()">
      @for (option of options; track option) {
        <label class="apple-multiselect-option">
          <input
            [type]="multiple ? 'checkbox' : 'radio'"
            [name]="multiple ? '' : 'apple-select-' + placeholder"
            [value]="option"
            [checked]="isSelected(option)"
            (change)="toggleOption(option, $event)"
            >
          <span [class]="multiple ? 'checkmark' : 'radiomark'"></span>
          <span class="option-text">{{ option }}</span>
        </label>
      }
    </div>
  </ng-template>
</div>
